import type { IconDef } from '../types';

export const topArrow: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M3.45019 9.62401C3.84035 10.0142 4.47061 10.0142 4.86078 9.62401L11.0834 3.40142L11.0834 22.9996C11.0834 23.5498 11.5336 24 12.0838 24C12.634 24 13.0842 23.5498 13.0842 22.9996L13.0842 3.40142L19.2968 9.62401C19.687 10.0142 20.3172 10.0142 20.7074 9.62401C21.0975 9.23385 21.0975 8.60358 20.7074 8.21342L12.7841 0.290118C12.584 0.0900357 12.3339 -7.57616e-07 12.0738 -7.80355e-07C11.8137 -8.03094e-07 11.5636 0.10004 11.3635 0.290118L3.44019 8.21342C3.05002 8.60358 3.05002 9.23385 3.44018 9.62401L3.45019 9.62401Z',
    },
  ],
};
